import React, { useEffect, useState } from 'react';
import { WordItem } from '@/types';
import './index.less';
import { getUnknownWord } from '@/apis';
import { message } from 'antd';
import NewWordCard from './word-card';

interface IProps {
    questionId: number;
    questionTitle: string;
}

const VocabularyNotebook = (props: IProps) => {
    const { questionId, questionTitle } = props;
    // 单词卡片
    const [wordCardPosition, setWordCardPosition] = useState({ x: 0, y: 0 });
    const [clickWord, setClickWord] = useState<WordItem>();
    const [wordVisible, setWordVisible] = useState(false);
    const [disposeTitle, setDisposeTitle] = useState(questionTitle);
    const [newWordList, setNewWorldList] = useState<WordItem[]>([]);

    const reqNewWork = async () => {
        // 获取生词列表
        const ret = await getUnknownWord({ questionId });
        if (ret.status === 0) {
            const wordList = ret.result;
            if (!wordList) {
                message.error(`获取生词列表失败！${ret.message}`);
                return;
            }
            setNewWorldList(ret.result || []);
            let title = `<span>${questionTitle}</span>`;
            wordList.forEach((item: { englishWord: string; wordId: number }) => {
                const reg = new RegExp(`([>]+[^<]*[^A-Za-z0-9/"]?)(${item.englishWord})([^A-Za-z0-9=/])`, 'g');
                title = title.replace(reg, `$1<span class="sub-tiku__question-finance-word" data-id="${item.wordId}">$2</span>$3`);
            });
            setDisposeTitle(title);
        }
    };

    useEffect(() => {
        reqNewWork();
    }, [questionId]);

    const handleClickNewWord = (e: any) => {
        const target = e.target || e.srcElement;
        const wordId = target.dataset.id ? +target.dataset.id : undefined;
        const currentWord = newWordList.find(item => item.wordId === wordId);

        if (currentWord) {
            setWordCardPosition({
                x: e.pageX,
                y: e.pageY,
            });
            setClickWord(currentWord);
            setWordVisible(true);
        }
    };

    return (
        <>
            <span dangerouslySetInnerHTML={{ __html: disposeTitle }} onClick={handleClickNewWord} />
            <NewWordCard
                closed={() => setWordVisible(false)}
                position={wordCardPosition}
                questionId={questionId}
                visible={wordVisible}
                wordItem={clickWord!}
            />
        </>
    );
};

export default VocabularyNotebook;
